const IS_LOADING = "list/billing_cycles/IS_LOADING";
const IS_ERROR = "list/billing_cycles/IS_ERROR";
const DATA = "list/billing_cycles/DATA";
export { IS_LOADING, IS_ERROR, DATA };
